'use client'

import React, { ReactElement } from 'react'
import { Room } from '@/types/Misc'
import CheckIcon from '@/icons/font-awesome/sharp-light/check.svg'
import HotelRoomModalImageSlider from './HotelRoomModalImageSlider'
import { Image } from '@/components/common/Image'
import { AwesomeIconDynamicClient } from '@/components/common/AwesomeIconDynamicClient'

export function HotelRoomModal(props: { room: Room }): ReactElement {
  const sliderElements = props.room.roomImages.map((image, index) => ({
    image: <Image filename={image.fileName} width={640} height={360} key={index} alt="" />,
    caption: image.caption,
  }))

  return (
    <>
      {sliderElements.length === 1 && sliderElements[0].image}
      {sliderElements.length > 1 && <HotelRoomModalImageSlider sliderElements={sliderElements} />}

      <div className="flex flex-col justify-center p-5">
        <h4 className="mb-2 text-2xl font-bold text-stone-900">{props.room.name}</h4>
        {props.room.popularFeatures && props.room.popularFeatures.length > 0 && (
          <div className="mb-6 flex flex-wrap items-center justify-start gap-x-4 gap-y-1 text-sm text-stone-600">
            {props.room.popularFeatures.map((feature) => (
              <div className="flex flex-row items-center" key={feature.text}>
                <AwesomeIconDynamicClient icon={feature.icon} />
                {feature.text}
              </div>
            ))}
          </div>
        )}

        <div
          dangerouslySetInnerHTML={{ __html: props.room.description }}
          className="prose prose-sm mb-6"
        ></div>

        <div className="grid grid-cols-3 gap-2 text-stone-600">
          {props.room.features.map((group, index) => (
            <div key={index}>
              <div className="mb-1 text-sm font-bold">{group.group}</div>
              {group.features.map((feature, index) => (
                <div key={index} className="mb-1 flex gap-1 break-words text-sm text-stone-600">
                  <CheckIcon className={'mt-1.5 h-3 w-3'} />
                  {feature.text}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </>
  )
}
